import React from 'react';

import {PreviousMeetingsWidgetProps} from "../models/previous-meetings-widget.props";
import {EntityDisplayName} from "../../../core/components/entity-display-name";
import styles from "../styles/previous-meetings-widget.match-row.module.scss";
import classNames from "classnames";
import {GameH2hCompetitorViewModel} from "../../../domain/h2h/models/competitor/game-h2h.competitor.view-model";

export class PreviousMeetingsWidgetRowCompetitorComponentProps extends PreviousMeetingsWidgetProps {
  competitor: GameH2hCompetitorViewModel;
  isAway: Boolean;
}

export const PreviousMeetingsWidgetMatchRowCompetitor = ({
                                                           competitor,
                                                           isAway,
                                                           shouldRenderOdds
                                                         }: PreviousMeetingsWidgetRowCompetitorComponentProps) => {
  return (
      <>
        <div className={classNames({[styles.content_loser]: !competitor.isWinner},
            {'bold': competitor.isWinner}, {[styles.away_competitor]: isAway}, {[styles.home_competitor]: !isAway}, {[styles.show_odds]: shouldRenderOdds})}>
          <EntityDisplayName entity={competitor} className={classNames(styles.competitor_name)}/>
        </div>
        <div className={classNames(styles.competitor_extra_data_title,{[styles.away_competitor]: isAway}, {[styles.home_competitor]: !isAway})}>{competitor.extraDataTitle}</div>
      </>

  )
};
